import { COVERAGE_FORM, COVERAGE_NAMES } from "@platform/rfp-core";

import { State } from "./types";

export const { DENTAL, DENTAL_PPO, DENTAL_DHMO } = COVERAGE_NAMES;
export const { PLAN_TYPE } = COVERAGE_FORM;
export const COVERAGE_STEP = 0;
export const FORM_STEP = 1;

export const initialState: State = {
  currentStep: COVERAGE_STEP,
  currentCoverageDetails: null,
  currentPlanIndex: 0,
  nextStepDetails: null,
  selectedCoverages: {
    clientProducts: [],
    products: [],
  },
};
